import {
  createErrorCodeProvider,
  registerErrorCodeProvider,
  registerVersionRange,
  type ErrorDetails,
} from './ErrorCodeProvider';

// V1.0 Error codes (valid for 1.0.x and 1.1.x)
const v1_0ErrorLookup = (
  code: number,
  group?: number
): ErrorDetails | undefined =>
  ({
    1: {
      shortDescription: 'No response from hardware',
      explanation:
        'It is likely that you have incorrect serial settings configured for the Atmo device or you have an incorrect or no connection between the hardware and the Atmo device',
    },
    2: {
      shortDescription: 'Data corruption',
      explanation:
        'It is likely that the cable connecting Atmo to your hardware is of poor quality or is damaged. It is also possible this was caused by interference',
    },
    3: group
      ? {
          shortDescription: 'Modbus error',
          explanation: `Illegal use of Modbus function in instruction group ${group}`,
        }
      : {
          shortDescription: 'Modbus error',
          explanation:
            'Illegal use of Modbus function in response to a read/write command',
        },
    4: group
      ? {
          shortDescription: 'Modbus error',
          explanation: `Attempt to read illegal address in instruction group ${group}`,
        }
      : {
          shortDescription: 'Modbus error',
          explanation:
            'Attempt to read illegal address in response to a read/write command',
        },
    5: {
      shortDescription: 'Modbus error',
      explanation: 'Illegal value written in response to a write command',
    },
    6: group
      ? {
          shortDescription: 'Modbus error',
          explanation: `Other Modbus error in instruction group ${group}`,
        }
      : {
          shortDescription: 'Modbus error',
          explanation: 'Other Modbus error in response to a read/write command',
        },
    7: {
      shortDescription: 'No instruction found',
      explanation:
        'The Atmo device has no instruction. a setup command is required',
    },
  })[code];

// Register V1.0 provider - Map versions 1.0 - 1.1 to use the 1.0 provider
registerErrorCodeProvider(createErrorCodeProvider('1.0', v1_0ErrorLookup));
registerVersionRange('1.0', ['1.0', '1.1']);

const v1_2ErrorLookup = (
  code: number,
  group?: number
): ErrorDetails | undefined =>
  ({
    1: {
      shortDescription: 'No response from hardware',
      explanation:
        'It is likely that you have incorrect serial settings configured for the Atmo device or you have an incorrect or no connection between the hardware and the Atmo device',
    },
    2: {
      shortDescription: 'Data corruption',
      explanation:
        'It is likely that the cable connecting Atmo to your hardware is of poor quality or is damaged. It is also possible this was caused by interference',
    },
    3: {
      shortDescription: 'Modbus error',
      explanation: `Modbus slave address mismatch`,
    },
    4: {
      shortDescription: 'Modbus error',
      explanation: 'Modbus function code mismatch',
    },
    5: {
      shortDescription: 'Modbus error',
      explanation: 'Modbus data byte count mismatch',
    },
    6: group
      ? {
          shortDescription: 'Modbus error',
          explanation: `Illegal use of Modbus function in instruction group ${group}`,
        }
      : {
          shortDescription: 'Modbus error',
          explanation:
            'Illegal use of Modbus function in response to a read/write command',
        },
    7: group
      ? {
          shortDescription: 'Modbus error',
          explanation: `Attempt to read illegal address in instruction group ${group}`,
        }
      : {
          shortDescription: 'Modbus error',
          explanation:
            'Attempt to read illegal address in response to a read/write command',
        },
    8: {
      shortDescription: 'Modbus error',
      explanation: 'Illegal value written in response to a write command',
    },
    9: group
      ? {
          shortDescription: 'Modbus error',
          explanation: `Other Modbus error in instruction group ${group}`,
        }
      : {
          shortDescription: 'Modbus error',
          explanation: 'Other Modbus error in response to a read/write command',
        },
    10: {
      shortDescription: 'No instruction found',
      explanation:
        'The Atmo device has no instruction. a setup command is required',
    },
    11: {
      shortDescription: 'Buffer overflow',
      explanation: 'Too much data has been requested',
    },
  })[code];

registerErrorCodeProvider(createErrorCodeProvider('1.2', v1_2ErrorLookup));
registerVersionRange('1.2', ['1.2', '2.0']);
